"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingCard = void 0;
var react_1 = __importDefault(require("react"));
var FloatingCard = function (_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    var classes = ['floating-card', className].filter(Boolean).join(' ');
    return (react_1.default.createElement("div", { className: classes, style: style }, children));
};
exports.FloatingCard = FloatingCard;
